import React from "react";

import css from "./sortable_header.less";

const sortableHeader = (label, attr, applyFilters, order) => {
  const active = order && order.indexOf(attr) === 0;

  return (
    <a className={css.link} onClick={() => applyFilters(attr)}>
      {label}
      {active && <small>{order.indexOf("asc") > 0 ? "▲" : "▼"}</small>}
    </a>
  );
};

export default sortableHeader;
